/* Femieko: pagina Favorite (sections/fe-favorite.liquid). Citește lista din localStorage („fe_fav_v1”, scrisă de fe-fav.js),
   încarcă fiecare produs din /products/<handle>?view=fe-fav și permite alegerea mărimii + adăugarea în coș.
   Inimioara de pe card scoate produsul (fe-fav.js trimite „fe-fav:change”). Produsele care nu mai există (404) ies din listă. */
(() => {
  if (customElements.get('fe-favorites')) return;
  const KEY = 'fe_fav_v1';
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const read = () => {
    if (window.FeFav) return window.FeFav.read();
    try { const a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter((x) => x && Number(x.id)) : []; } catch (e) { return []; }
  };
  const drop = (id) => {
    const a = read().filter((x) => Number(x.id) !== Number(id));
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) { /* stocare indisponibilă */ }
  };
  const HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-9.2-9.4C1.8 7.8 3.7 4.6 7 4.3c2-.2 3.7.9 5 2.6 1.3-1.7 3-2.8 5-2.6 3.3.3 5.2 3.5 4.2 6.6-1.6 4.8-9.2 9.4-9.2 9.4z"/></svg>';

  class FeFavorites extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.countEl = this.querySelector('[data-count]');
      this.cache = new Map();
      this.addEventListener('change', (e) => this.onVariant(e));
      this.addEventListener('click', (e) => this.onAdd(e));
      document.addEventListener('fe-fav:change', (e) => { if (!e.detail.on) this.removeCard(e.detail.id); });
      window.addEventListener('storage', (e) => { if (e.key === KEY) this.render(); });
      this.render();
    }

    t(k, n) { const s = this.dataset['t' + k] || ''; return n == null ? s : s.replace('[n]', n); }

    setCount(n) {
      this.countEl.textContent = n ? (n === 1 ? this.t('Count1') : this.t('Count', n)) : '';
      this.empty.hidden = n > 0;
      this.grid.hidden = n === 0;
    }

    async load(item) {
      if (this.cache.has(item.id)) return this.cache.get(item.id);
      const root = (this.dataset.root || '/').replace(/\/?$/, '/');
      try {
        const r = await fetch(root + 'products/' + encodeURIComponent(item.h) + '?view=fe-fav', { credentials: 'same-origin' });
        if (r.status === 404) { drop(item.id); return null; }
        if (!r.ok) return null;
        const p = JSON.parse((await r.text()).trim());
        if (!p || Number(p.id) !== Number(item.id)) { if (p && p.id) drop(item.id); return null; }
        p._h = item.h;
        this.cache.set(item.id, p);
        return p;
      } catch (e) {
        return null;
      }
    }

    async render() {
      const list = read();
      if (!list.length) { this.grid.innerHTML = ''; this.setCount(0); return; }
      const products = (await Promise.all(list.map((x) => this.load(x)))).filter(Boolean);
      this.grid.innerHTML = products.map((p) => this.card(p)).join('');
      this.setCount(products.length);
      if (window.FeFav) window.FeFav.sync(this);
    }

    pick(p) {
      return p.v.find((x) => x.a) || p.v[0];
    }

    card(p) {
      const v = this.pick(p);
      const single = p.v.length === 1 && p.v[0].n === 'Default Title';
      const avail = p.v.filter((x) => x.a);
      let action;
      if (p.sp) {
        action = '<a class="fe-favs__btn fe-favs__btn--ghost" href="' + esc(p.u) + '">' + esc(this.t('ViewProduct')) + '</a>';
      } else if (!avail.length) {
        action = '<button class="fe-favs__btn" type="button" disabled>' + esc(this.t('SoldOut')) + '</button>';
      } else {
        const sel = single ? '' : '<label class="fe-favs__sel"><span class="fe-favs__label">' + esc(this.t('Size')) + '</span><select data-variant>' +
          avail.map((x) => '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.n) + '</option>').join('') + '</select></label>';
        action = sel + '<button class="fe-favs__btn" type="button" data-add>' + esc(this.t('AddCart')) + '</button>';
      }
      return '<li class="fe-favs__card" data-pid="' + p.id + '">' +
        '<div class="fe-favs__media"><a href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="" width="600" height="600" loading="lazy" decoding="async">' : '') + '</a>' +
        '<button type="button" class="fe-fav fe-fav--card is-on" data-fe-fav data-id="' + p.id + '" data-handle="' + esc(p._h) + '" aria-pressed="true" aria-label="' + esc(this.t('Remove')) + '" title="' + esc(this.t('Remove')) + '">' + HEART + '</button></div>' +
        '<div class="fe-favs__body"><h2 class="fe-favs__name"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h2>' +
        '<div class="fe-favs__price" data-price>' + this.priceHtml(v) + '</div>' + action +
        '<p class="fe-favs__error" data-error role="alert" hidden></p></div></li>';
    }

    priceHtml(v) {
      return '<span>' + esc(v.p) + '</span>' + (v.c ? '<s>' + esc(v.c) + '</s>' : '');
    }

    onVariant(e) {
      const sel = e.target.closest('select[data-variant]');
      if (!sel) return;
      const li = sel.closest('[data-pid]');
      const p = this.cache.get(Number(li.dataset.pid)) || [...this.cache.values()].find((x) => x.id === Number(li.dataset.pid));
      const v = p && p.v.find((x) => x.id === Number(sel.value));
      if (v) li.querySelector('[data-price]').innerHTML = this.priceHtml(v);
    }

    removeCard(id) {
      const li = this.grid.querySelector('[data-pid="' + Number(id) + '"]');
      if (li) li.remove();
      this.setCount(this.grid.querySelectorAll('[data-pid]').length);
    }

    async onAdd(e) {
      const btn = e.target.closest('[data-add]');
      if (!btn) return;
      const li = btn.closest('[data-pid]');
      const p = this.cache.get(Number(li.dataset.pid));
      if (!p) return;
      const sel = li.querySelector('select[data-variant]');
      const id = sel ? Number(sel.value) : this.pick(p).id;
      const err = li.querySelector('[data-error]');
      err.hidden = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(this.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!r.ok) {
          const d = await r.json().catch(() => ({}));
          throw new Error(d.description || d.message || String(r.status));
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && !(window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cartType === 'page')) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        } else {
          window.location.href = this.dataset.cartUrl;
        }
      } catch (ex) {
        err.textContent = this.t('Error') + (ex.message && !/^\d+$/.test(ex.message) ? ' (' + ex.message + ')' : '');
        err.hidden = false;
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('fe-favorites', FeFavorites);
})();
